module.exports = __webpack_public_path__ + "static/media/parking.f3ff251a.jpg";